import React from 'react';

import { CheckIcon } from '@vlabs/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './ColorPicker.module.sass';

const DEFAULT_COLOR_OPTIONS = [
  { colorKey: 'positive', colorVariable: '--color-positive-variant' },
  { colorKey: 'accentOrange', colorVariable: '--color-accent-orange' },
  { colorKey: 'accentBlue', colorVariable: '--color-accent-blue' },
  { colorKey: 'accentRed', colorVariable: '--color-accent-red' },
  { colorKey: 'alwaysBlack', colorVariable: '--color-always-black' },
];

export const ColorPicker = ({
  value,
  onChange,
  colors = DEFAULT_COLOR_OPTIONS,
}) => {
  const { t } = useTranslation();

  return (
    <div className={st.Root}>
      <span className={st.Label}>{t('color')}</span>
      <ul className={st.ColorList}>
        {colors.map(({ colorKey, colorVariable }) => (
          <li className={st.ColorListItem} key={colorKey}>
            <button
              aria-label={`Select ${colorKey} color`}
              className={st.Color}
              data-testid={`detectionSettings.colorPicker.${colorKey}.selectButton`}
              onClick={() => onChange(colorKey)}
              style={{ backgroundColor: `var(${colorVariable})` }}
              type="button"
            >
              {colorKey === value && <CheckIcon className={st.SelectedColorIcon} size="small" />}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  colors: PropTypes.arrayOf(PropTypes.shape({
    colorKey: PropTypes.string.isRequired,
    colorVariable: PropTypes.string.isRequired,
  })),
};
